import * as React from 'react';
import * as cardStyle from './service-card.module.scss';
import {Link} from "gatsby";

const ServiceCard = ({title, img, href}) => {
    return (
        <Link to={href}>
            <div className={cardStyle.cardBox + " card shadow-sm"}>
                <img className="mx-auto pt-2" src={img} alt={title} />
                <div className="card-body text-center">{title}</div>
            </div>
        </Link>
    )
}
export default ServiceCard